import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import OfflineLockoutScreen from './OfflineLockoutScreen';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { authenticated, offlineLocked, login } = useAuth();

  useEffect(() => {
    if (!authenticated && !offlineLocked) {
      login();
    }
  }, [authenticated, offlineLocked, login]);

  if (offlineLocked) {
    return <OfflineLockoutScreen />;
  }

  if (!authenticated) {
    return null;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
